export enum FormOneBStatus {
    Queued = 0,
    Received,
    Success,
    Error,
    Archived,
    Working
}